<template>
    <div class="vertical-menu w-full lg:w-1/6 mr-0 lg:mr-8">
        <ul :class="['vertical-menu__list border-l-2 mb-12 lg:mb-auto border-solid border-gray-200 font-semibold text-sm', menuFixed ? 'lg:fixed top-12' : 'lg:absolute']">
            <li v-for="(item, key) in items"
                :class="['vertical-menu__list__item border-transparent border-l-4 cursor-pointer', item.active ? 'active' : '']">
                <div @click="() => updateUrlParams(item.slug)" class="py-1 pl-2 block link-primary link-primary--mobile">
                    {{ $__(item.title) }}
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        props: ['tabRefs', 'items', 'menuFixed'],
        methods: {
            updateUrlParams(subjectSlug) {
                this.$emit('updateUrlParams', subjectSlug);
            }
        }
    }
</script>
